import SectionCard from './section-card';

export default SectionCard;
export {SectionCard};